import React from 'react';
import { TFunction } from 'i18next';
import Field from 'assets/icons/field.svg';
import Separator from 'assets/icons/divider_vertical.svg';
import { getCropIcon } from './heroBannerUtils';

interface FieldDetailsProps {
  totalFields: number;
  fieldSummaryArea: string;
  cropNameLowerCase: string;
  cropName: string;
  t: TFunction;
  isMobile?: boolean;
  renderDesktop?: (content: JSX.Element) => JSX.Element;
  renderMobilePrimary?: (content: JSX.Element) => JSX.Element;
  renderMobileSecondary?: (content: JSX.Element) => JSX.Element;
  testId?: string;
  showFieldInfo?: boolean;
}

const FieldDetails: React.FC<FieldDetailsProps> = ({
  totalFields,
  fieldSummaryArea,
  cropNameLowerCase,
  cropName,
  t,
  isMobile = false,
  renderDesktop,
  renderMobilePrimary,
  renderMobileSecondary,
  showFieldInfo = true,
}) => {
  const cropContent = (
    <>
      <img
        src={getCropIcon(cropNameLowerCase)}
        alt={`${cropName} icon`}
        className="icon-size crop-icon"
      />
      {cropName}
    </>
  );

  if (isMobile && renderMobilePrimary && renderMobileSecondary) {
    const primaryContent = (
      <>
        <img src={Field} alt="Field icon" className="icon-size field-image" />
        {totalFields && totalFields > 1
          ? `${totalFields} ${t('fields')}`
          : `${totalFields} ${t('field')}`}
        <div className="white-dot" />
        {`${Number.parseFloat(fieldSummaryArea).toFixed(2)} ${t('ha')}`}
      </>
    );

    const secondaryContent = cropContent;

    if (!showFieldInfo) {
      return <>{renderMobilePrimary(secondaryContent)}</>;
    }

    return (
      <>
        {renderMobilePrimary(primaryContent)}
        {renderMobileSecondary(secondaryContent)}
      </>
    );
  }

  const desktopContent = showFieldInfo ? (
    <>
      <img src={Field} alt="Field icon" className="icon-size field-image" />
      {totalFields && totalFields > 1
        ? `${totalFields} ${t('fields')}`
        : `${totalFields} ${t('field')}`}{' '}
      <div className="white-dot" />
      {`${Number.parseFloat(fieldSummaryArea).toFixed(2)} ${t('ha')}`}
      <img src={Separator} alt="separator" className="separator-icon" />
      {cropContent}
    </>
  ) : (
    <>{cropContent}</>
  );

  return renderDesktop ? renderDesktop(desktopContent) : <>{desktopContent}</>;
};

export default FieldDetails;
